import firebaseApp from "../../firebase/credenciales";
import React from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getProductos(nombrecategoria) {
    

  //console.log(valor);
    const productosDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Almacen_campo/"+nombrecategoria+"/Productos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productosDB.push(doc.data());
    });
    return productosDB;
    

}


//"+productofolio+"
